<template>
  <el-dialog
    v-if="!!response"
    :visible.sync="paymentDialog"
    width="60%"
    custom-class="bids-opl-dialog"
    destroy-on-close
    :close-on-click-modal="true"
    :before-close="() => $emit('close')"
  >
    <h2 slot="title" class="bids-opl-dialog__title">
      Информации по стоимости перевозки
    </h2>
    <el-row v-if="response" class="plates">
      <span v-if="!!response.auto">
        Авто: {{ response.auto.state_numbers || 'Н/Д' }}
      </span>
      <span v-if="!!response.auto">
        Прицеп: {{ response.auto.state_numbers_trailer || 'Н/Д' }}
      </span>
      <span v-if="!!activeAct">
        Номер Акта: {{ activeAct.number || 'Н/Д' }}
      </span>
      <span v-if="!!activeAct">
        Дата Акта:
        {{ dateToFormat(activeAct.document_create_date) || 'Н/Д' }}
      </span>
    </el-row>
    <el-row>
      <el-col :span="11">
        <template v-for="(row, k) in paymentDialogData">
          <div :key="k" class="bids-opl-dialog__col">
            <bids-list-table-row
              :label="row.label"
              :value="row.value || ''"
              :color="row.color || ''"
            />
          </div>
        </template>
      </el-col>
      <el-col :span="11" :offset="1">
        <template v-for="(row, k) in paymentDialogData2">
          <div :key="k" class="bids-opl-dialog__col">
            <bids-list-table-row
              :label="row.label"
              :value="row.value || ''"
              :color="row.color || ''"
            />
          </div>
        </template>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="23">
        <hr />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="11" :offset="12">
        <div class="bids-opl-dialog__col">
          <bids-list-table-row
            v-if="response"
            label="Осталось оплатить"
            :value="response.payment_left || 0"
          />
        </div>
      </el-col>
    </el-row>
    <div class="bids-opl-dialog__payinfo">
      <h2 class="bids-opl-dialog__title">Информации по платежам:</h2>
      <div v-if="oplTableData.length" class="bids-opl-dialog__table">
        <el-table v-loading="loading" :data="oplTableData" style="width: 100%">
          <el-table-column prop="createdAt" label="Создан" width="150" />
          <el-table-column prop="price" label="Сумма" width="120">
            <template slot-scope="{ row }">
              <span class="bids-opl-dialog__price"> {{ row.price }} руб </span>
            </template>
          </el-table-column>
          <el-table-column prop="purpose" label="Назначение" width="180" />
          <el-table-column
            prop="payment_number"
            label="Номер платежа"
            width="180"
          >
            <template slot-scope="{ row }">
              <bids-payment-modal-item :item="row" />
            </template>
          </el-table-column>
          <el-table-column prop="paidAt" label="Оплачен" width="130">
            <template slot-scope="{ row }">
              <span
                :class="[
                  'bids-opl-dialog__payment',
                  { 'is-link': row.payment_date === 'action' },
                ]"
              >
                <span v-if="!row.payment_date">Поставить статус оплачен</span>
                <span v-else>{{ row.payment_date }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="paidAt" width="80">
            <template slot-scope="{ row }">
              <span
                v-if="row.isDownload"
                class="bids-opl-dialog__download"
                @click="downloadPayment(row.id)"
              >
                <i class="el-icon-download" />
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Удалить" width="90" align="center">
            <template slot-scope="{ row }">
              <span class="bids-opl-dialog__price">
                <el-link
                  v-if="row.isDelete"
                  :underline="false"
                  @click="deletePayment(row.id)"
                >
                  х
                </el-link>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else v-loading="loading" class="bids-opl-dialog__empty">
        Не было платежей
      </div>
      <div class="bids-opl-dialog__form">
        <el-form
          ref="paymentForm"
          :inline="true"
          :model="paymentForm"
          :rules="rules"
          label-position="top"
        >
          <el-form-item prop="sum" label="Сумма платежа">
            <el-input-number
              v-model="paymentForm.sum"
              :controls="false"
              placeholder="Сумма платежа"
            />
          </el-form-item>
          <el-form-item prop="payment_number" label="Номер платежа">
            <el-input
              v-model="paymentForm.payment_number"
              :controls="false"
              placeholder="Номер платежа"
            />
          </el-form-item>
          <el-form-item prop="is_advance" label="Назначение платежа">
            <el-select
              v-model="paymentForm.is_advance"
              :disabled="!paymentPurposes.length"
              placeholder="Назначение платежа"
            >
              <el-option
                v-for="item in paymentPurposes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="invisible">a</span>
            <el-button
              type="primary"
              icon="el-icon-plus"
              :loading="payingLoader"
              @click="addPayment"
            >
              Добавить
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-row>
      <el-col :span="24">
        <el-link type="primary" @click.stop="calculateAutoHandler">
          Расчитать авто
        </el-link>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { GET_PAYMENTS_BY_ID, SEND_PAYMENT } from '@/store/payments'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { fullDateWithTime } from '@/datas/DateFormats'
import { getDateOfCertainFormat } from '@/helpers/date'
import { mapGetters } from 'vuex'
import { roundUp } from '@/helpers/functions'
import BidsListTableRow from '@/components/BidsList/BidsListTableRow'
import BidsPaymentModalItem from './BidsPaymentModalItem'

const PaymentsApi = RepositoryFactory.get('payments')

export default {
  name: 'BidsPaymentsModal',
  components: { BidsListTableRow, BidsPaymentModalItem },
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    paymentDialog: {
      type: Boolean,
      required: true,
    },
    response: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      required: true,
    },
    payingLoader: {
      type: Boolean,
      required: true,
    },
    activeAct: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const validateNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Поле обязательное!'))
      } else {
        if (value <= 0) {
          callback(new Error('Не может быть меньше 0!'))
        }
        callback()
      }
    }

    return {
      paymentForm: {
        sum: '',
        is_advance: '',
        payment_number: '',
      },
      isEditPaymentNumber: false,
      paymentPurposesDef: [
        { label: 'Простой', value: 0 },
        { label: 'Аванс', value: 1 },
        { label: 'Оплата перевозки', value: 2 },
      ],
      rules: {
        sum: [
          {
            required: true,
            message: 'Добавите сумму платежа',
            trigger: 'blur',
          },
          { validator: validateNumber, trigger: 'blur' },
        ],
        is_advance: [
          {
            required: true,
            message: 'Добавите назначение платежа',
            trigger: 'blur',
          },
        ],
        payment_number: [{ required: false }],
      },
    }
  },
  computed: {
    ...mapGetters({
      paymentsList: 'payments/getPayments',
    }),
    paymentPurposes() {
      if (this.loading) {
        return []
      }
      if (this.paymentsList.find(p => p.is_advance === 1)) {
        return [{ label: 'Оплата перевозки', value: 0 }]
      }

      return this.paymentPurposesDef
    },
    oplTableData() {
      return this.paymentsList.map(el => ({
        ...el,
        createdAt: getDateOfCertainFormat(el.created_at, fullDateWithTime),
        price: el.sum,
        purpose: this.getPurpose(el.is_advance),
        isDelete: !el.payment_date,
        isDownload: el.payment_date,
        payment_date: el.payment_date
          ? getDateOfCertainFormat(el.payment_date, fullDateWithTime)
          : null,
        paidAt: getDateOfCertainFormat(el.updated_at, fullDateWithTime),
      }))
    },
    paymentDialogData() {
      const deficiencyValue =
        (this.response.deficiency || 0) -
        (this.response.acceptable_deficiency || 0)
      const { price_from_storage_bidder, price_from_field_bidder } =
        this.response
      let price = ''

      if (this.bid.type_code !== 'harvest') {
        price += roundUp(price_from_storage_bidder, 1000)
      }
      if (this.bid.type_code === 'harvest_or_delivery') {
        price += '(П), '
      }
      if (this.bid.type_code !== 'delivery') {
        price += roundUp(price_from_field_bidder, 1000)
      }
      if (this.bid.type_code === 'harvest_or_delivery') {
        price += '(У)'
      }

      return [
        {
          label: 'Цена перевозки',
          value: `${price} руб/кг`,
        },
        { label: 'Объем перевозки', value: `${this.response.volume || 0} кг` },
        { label: 'Недовоз', value: `${this.response.deficiency || 0} кг` },
        {
          label: 'Недовоз сверх нормы',
          value: `${roundUp(deficiencyValue)} кг`,
          color: 'danger',
        },
      ]
    },
    paymentDialogData2() {
      return [
        {
          label: 'Стоимость перевозки',
          value: `${this.response.cost_amount || 0} руб`,
        },
        {
          label: 'Вычет за недовоз',
          value: `${this.response.deficiency_cost || 0} руб`,
        },
        {
          label: 'Аванс',
          value: `${this.response.avance || 0} руб`,
          color: 'success',
        },
        { label: 'Оплата', value: `${this.response.payment || 0} руб` },
      ]
    },
    payRemainder() {
      return `${this.calculatePayRemainder} руб`
    },
    calculatePayRemainder() {
      return (this.response.avance || 0) - (this.response.payment || 0)
    },
  },
  watch: {
    response: {
      immediate: true,
      handler(val) {
        if (val?.id && this.paymentDialog) {
          this.$store.dispatch(`payments/${GET_PAYMENTS_BY_ID}`, val.id)
        }
      },
    },
    'paymentsList.length': {
      handler(val, oldVal) {
        if (this.$refs.paymentForm && val > oldVal) {
          this.$refs.paymentForm.resetFields()
        }
      },
    },
    'paymentPurposes.length': {
      handler(val) {
        if (val === 1) {
          this.paymentForm.is_advance = (
            this.paymentPurposes.find(c => c) || {}
          ).value
        } else {
          this.paymentForm.is_advance = ''
        }
      },
      immediate: true,
    },
  },
  methods: {
    getPurpose(val) {
      switch (val) {
        case 0:
          return 'Оплата перевозки'
        case 1:
          return 'Аванс'
        default:
          return ''
      }
    },
    calculateAutoHandler() {
      this.paymentForm.is_advance = 0
      this.paymentForm.sum = this.calculatePayRemainder
    },
    addPayment() {
      this.$refs.paymentForm.validate(valid => {
        if (valid) {
          if (!this.response || !this.response.id) {
            return
          }
          const { payment_number, is_advance, sum } = this.paymentForm
          const payment = { response_id: this.response.id, sum, is_advance }

          if (payment_number !== '') {
            payment.payment_number = payment_number
          }

          this.$store.dispatch(`payments/${SEND_PAYMENT}`, payment).then(() => {
            this.$emit('update', false, this.response.id)
          })
        }
      })
    },
    deletePayment(id) {
      this.$store.dispatch('payments/DELETE_PAYMENT', id).then(() => {
        this.$emit('update', false, this.response.id)
      })
    },
    async downloadPayment(id) {
      this.downloadRegistry({ path: PaymentsApi.print(id) })
    },
  },
}
</script>

<style lang="scss">
.plates {
  font-size: 14px;
  margin-bottom: 15px;
  & span {
    margin-left: 15px;
    &:first-child {
      margin-left: 0;
    }
  }
}
.bids-opl-dialog {
  min-width: 700px !important;
  &__title {
    margin-top: 0;
    color: #000;
  }
  &__col {
    color: #000;
    margin-bottom: 10px;
  }
  &__download {
    display: inline-block;
    padding: 3px;
    cursor: pointer;

    i.el-icon-download {
      font-size: 24px;
    }
  }
  &__empty {
    color: #d7d7d7;
    font-size: 18px;
    padding: 10px 0;
    font-weight: 600;
    text-transform: uppercase;
  }
  &__payinfo {
    margin-top: 40px;
  }
  &__payment {
    &.is-link {
      text-decoration: underline;
      color: #409eff;
      cursor: pointer;
    }
  }
  &__form {
    margin-top: 30px;
  }
  .invisible {
    color: transparent !important;
    user-select: none;
  }
}
</style>
